module.exports = __webpack_public_path__ + "img/share.07306eeb.png";